module.exports = __webpack_public_path__ + "fonts/Nunito-500-latin15.86b73ab.woff2";